__turbopack_context__.v({
  "arrow-icon": "PrimaryGroups-module-scss-module__1MkXJq__arrow-icon",
  "desktop": "PrimaryGroups-module-scss-module__1MkXJq__desktop",
  "group-listing": "PrimaryGroups-module-scss-module__1MkXJq__group-listing",
  "left": "PrimaryGroups-module-scss-module__1MkXJq__left",
  "listing-link": "PrimaryGroups-module-scss-module__1MkXJq__listing-link",
  "middle": "PrimaryGroups-module-scss-module__1MkXJq__middle",
  "mobile": "PrimaryGroups-module-scss-module__1MkXJq__mobile",
  "primary-group": "PrimaryGroups-module-scss-module__1MkXJq__primary-group",
  "right": "PrimaryGroups-module-scss-module__1MkXJq__right",
  "sublisting": "PrimaryGroups-module-scss-module__1MkXJq__sublisting",
  "sublisting-item": "PrimaryGroups-module-scss-module__1MkXJq__sublisting-item",
  "sublisting-link": "PrimaryGroups-module-scss-module__1MkXJq__sublisting-link",
  "tablet": "PrimaryGroups-module-scss-module__1MkXJq__tablet",
  "wrappable": "PrimaryGroups-module-scss-module__1MkXJq__wrappable",
});
